export const LOGO_FALLBACK_SRC = '/images/integration-fallback.svg';

// `@error` handler for integration logo <img> tags: swap a 404ing logo for the generic icon
// instead of showing a broken image. Clears the handler first so a failing fallback can't loop.
export function onLogoError(event: Event) {
    const img = event.target as HTMLImageElement | null;
    if (!img || img.src.endsWith(LOGO_FALLBACK_SRC)) return;
    img.onerror = null;
    img.src = LOGO_FALLBACK_SRC;
}
